import React from "react";

const SelectField = ({
  label,
  id,
  value,
  onChange,
  required = false,
  options = [],
  labelClassName = "auth-label",
  selectClassName = "auth-input",
  ...props
}) => {
  return (
    <>
      <label className={labelClassName} htmlFor={id}>
        {label}
        {required && <span className="required-star">*</span>}
      </label>
      <select
        id={id}
        className={selectClassName}
        value={value}
        onChange={onChange}
        {...props}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </>
  );
};

export default SelectField;
